import { useEffect, useState } from "react";

function ProgressIndicator({
    width,
    slide,
    index,
    controls,
    activeSlide,
    slideStarted = false,
    sliderStatus,
    setSlideStatus,
    videoControls,
}) {
    const [progress, setProgress] = useState(0);
    const [timer, setTimer] = useState(null);
    const initiateTimer = () => {
        let tempTimer = setInterval(() => {
            setProgress((progress) => {
                if (progress < slide.max) {
                    return progress + 200;
                } else {
                    controls?.next();
                    clearInterval(tempTimer);
                    setTimer((t) => null);
                    return progress;
                }
            });
        }, 200);
        setTimer((t) => tempTimer);
    };

    useEffect(() => {
        if (slideStarted) {
            if (sliderStatus == "paused") {
                setSlideStatus("playing");
            }

            clearInterval(timer);
            setTimer((t) => null);

            if (activeSlide == index) {
                setProgress(0);
                initiateTimer();
            } else {
                setProgress(index < activeSlide ? slide.max : 0);
            }

            if (activeSlide == 0) {
                videoControls?.restart();
            } else {
                videoControls?.pause();
            }
        }
    }, [activeSlide, slideStarted]);

    useEffect(() => {
        if (activeSlide == index && slideStarted) {
            if (sliderStatus == "paused") {
                clearInterval(timer);
                setTimer((t) => null);
            } else if (sliderStatus == "playing") {
                initiateTimer();
            }
        }
    }, [sliderStatus]);

    return (
        <div className="v-pt-progress-bar" style={{ width: width + "%" }}>
            <div
                className={`v-pt-progress ${
                    activeSlide == index ? "p-active" : ""
                }`}
                style={{ width: (progress / slide.max) * 100 + "%" }}
            />
        </div>
    );
}

export default ProgressIndicator;
